/* eslint-disable no-use-before-define */
import React from 'react'
import { STATE_NAMES } from '../../twd/values'
export default ({values}) => {

    let states = Object.entries(values)
        .map( ([state, data]) => [STATE_NAMES[state], data.tradeCount])
        .sort( (a,b) => (''+a[0]).localeCompare(''+b[0]))

    return (<React.Fragment>
    <table>
    <caption>Municpal map based upon the number of MSRB-reported trades from the previous trading day.</caption>
    <tbody>
    <tr>
        <th scope="col">State</th>
        <th scope="col">Trade Count</th>
    </tr>
    {
        states.map( ([state, cnt], i) => <tr key={i}>
            <td>{state}</td>
            <td>{cnt}</td>
        </tr>)

    }
    </tbody>
    </table>
    </React.Fragment>)
}

